import { Trip } from "@fairfleet/geotab";
import { isRealDriverId } from "@/utilities/user/isRealDriverId";

/**
 * The driver Geotab attached to the trip. The EcoApp logs the driver in with a DriverChange when
 * the driver books the vehicle and out again afterwards; Geotab copies that driver onto the trip.
 * Undefined when nobody was logged in.
 */
export function tripDriverId(trip: Pick<Trip, "driver">): string | undefined {
  const driver: unknown = trip.driver;
  const id =
    typeof driver === "string" ? driver : driver && typeof driver === "object" ? (driver as { id?: unknown }).id : undefined;
  return typeof id === "string" && isRealDriverId(id) ? id : undefined;
}
